var map = {
	"./ROOOM-hkg-central-wingwo-PROD-config.json": 211,
	"./SLEEEP-UAT-PROD-config.json": 212,
	"./bkk-silom-PROD-config.json": 213,
	"./hkg-cwb-PROD-config.json": 214,
	"./hkg-gough-PROD-config.json": 215,
	"./up-otel-hkg-ymt-PROD-config.json": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;